export default "__VITE_ASSET__DsaFGXpL__"